// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2Grh8","modalForm":"UpgradeEpcsModal_modalForm__2K98P","modalFooter":"UpgradeEpcsModal_modalFooter__acZp1"};